import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { MensajeVariosContactos } from "../interfaces/MensajeVariosContactosData";
import { Observable } from "rxjs";
import { ArchivoVariosContactos } from "../interfaces/ArchivoVariosContactosData";
import { MensajesPersonalizados } from "../interfaces/mensajePersonalizadoData";
import { ArchivosPersonalizados } from "../interfaces/archivoPersonalizadoData";

@Injectable({
    providedIn: 'root'
})

export class MensajesService{
    private baseApi = environment.baseApi + '/mensajes';

    constructor(private http: HttpClient){}

  enviarMensajeMuchosContactos(mensaje: MensajeVariosContactos, archivo: File | null): Observable<MensajeVariosContactos> {
    const formData = new FormData();
    const blob = new Blob([JSON.stringify(mensaje)], { type: "application/json" });
    console.log("Datos a enviar", mensaje);
    formData.append('lista', blob); 
    if (archivo) {
      formData.append('archivo', archivo); // Si hay un archivo, agregarlo al FormData
    }
    console.log(formData);
    return this.http.post<MensajeVariosContactos>(`${this.baseApi}/enviar-mensaje`, formData);
  }

  enviarArchivoMuchosContactos(archivo: ArchivoVariosContactos, archivoCSV: File | null): Observable<ArchivoVariosContactos> {
    const formData = new FormData();
    const blob = new Blob([JSON.stringify(archivo)], { type: 'application/json'});
    console.log("Datos a enviar", archivo);
    formData.append('lista', blob);
    if(archivoCSV){
      formData.append('archivo', archivoCSV);
    }
    console.log(formData);
    return this.http.post<ArchivoVariosContactos>(`${this.baseApi}/enviar-archivo`, formData);
  }

  enviarMensajePersonalizado(mensajePersonalizado: MensajesPersonalizados, archivoCSV: File | null): Observable<MensajesPersonalizados>{
    const formData = new FormData();
    const blob = new Blob([JSON.stringify(mensajePersonalizado)], { type: 'application/json'});
    console.log("Datos a enviar", mensajePersonalizado);
    formData.append('lista', blob);
    if(archivoCSV){
      formData.append('archivo', archivoCSV);
    }
    console.log(formData);
    return this.http.post<MensajesPersonalizados>(`${this.baseApi}/enviar-mensaje-personalizado`, formData);

  }

  enviarArchivoPersonalizado(archivoPersonalizado: ArchivosPersonalizados, archivoCSV: File | null): Observable<ArchivosPersonalizados>{
    const formData = new FormData();
    const blob = new Blob([JSON.stringify(archivoPersonalizado)], { type: 'application/json'});
    console.log("Datos a enviar", archivoPersonalizado);
    formData.append('lista', blob);
    if(archivoCSV){
      formData.append('archivo', archivoCSV);
    }
    console.log(formData);
    return this.http.post<ArchivosPersonalizados>(`${this.baseApi}/enviar-archivo-personalizado`, formData);

  }

}

